module.exports = __webpack_public_path__ + "static/media/vosges-alsace.ce2023c7.jpg";